import { AnyAction } from 'redux';
import { DesignState } from '../types';

const setDesignStatus = (state: DesignState, { designStatus }: AnyAction) => ({
  ...state,
  designStatus,
});

export default setDesignStatus;
